<script setup lang="ts">
import { type PropertyType } from '@/backend/types'
import { FIELD_TYPES_LABELS } from '@/modules/WorkspaceSettings/propertyConfig'

import { PROPERTY_TYPE_TOOLTIP_DATA } from './utils'

defineProps<{ type: PropertyType | 'auto' }>()
</script>

<template>
  <div class="flex w-[320px] flex-col rounded-corner-6 bg-surface-popover-inverted">
    <div class="flex flex-col">
      <Component :is="PROPERTY_TYPE_TOOLTIP_DATA[type].illustrationComponent" />
    </div>
    <div
      data-theme="dark"
      class="flex flex-col gap-1 p-3"
    >
      <h3 class="text-sm-12px-default text-text">
        {{ type === 'auto' ? 'Auto' : FIELD_TYPES_LABELS[type] }}
      </h3>
      <p class="text-sm-12px-light text-text-subtle">
        {{ PROPERTY_TYPE_TOOLTIP_DATA[type].description }}
      </p>
    </div>
  </div>
</template>
